import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

import { af } from '../theme';

const styles = {
  row: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${af.sp3};
    margin-bottom: ${af.sp8};
  `,
  stepName: css`
    display: flex;
    align-items: center;
    gap: 7px;
  `,
  tick: css`
    width: 6px;
    height: 6px;
    border-radius: 1.5px;
    background: ${af.ink};
    flex: 0 0 6px;
  `,
  track: css`
    margin-bottom: ${af.sp6};
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
